import { IPatientProfileRepository, PatientProfileInformation } from "../../../domain/patient";
import { PatientProfileInformationTranslator } from "../../../infrastructure/document/ver2/translators";
import { AuthenticatedService } from "../..";
import store from "../../../store";
import { IConfiguration } from "../../../domain/configuration";

export class PatientProfileRepository extends AuthenticatedService implements IPatientProfileRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }

  private readonly _translator = new PatientProfileInformationTranslator();

  async getPatientProfileInformation(patientId: string): Promise<PatientProfileInformation> {
    return this.executeGetPatientProfileInformation(patientId, false);
  }

  async getLatestPatientProfileInformation(patientId: string): Promise<PatientProfileInformation> {
    return this.executeGetPatientProfileInformation(patientId, true);
  }


  async executeGetPatientProfileInformation(patientId: string, isRecently: boolean): Promise<PatientProfileInformation> {
    // 患者プロフィールを使用しないサイトではapiを叩く必要なし
    const configuration = store.getters.configuration as IConfiguration;
    if (!configuration.behavior.document.editor.patientProfile.isEnable) {
      return this._translator.toPatientProfileInformation(null);
    }
    const url = "/api/patient/" + patientId + "/profile-information";
    const query = {
      params: {
        isRecently: isRecently, // フロントエンド内のprefetch対策として機能している
      }
    };
    const result = await this.get(url, query);
    return this._translator.toPatientProfileInformation(result.data);
  }

  async updatePatientProfileInformation(patientId: string, info: PatientProfileInformation): Promise<void> {
    if (!patientId) { throw new Error("patientId is empty!!!"); }
    const url = "/api/patient/" + patientId + "/profile-information/save";
    const translator = new PatientProfileInformationTranslator();
    const converted = translator.toPatientProfileInformationBean(info);
    await this.post(url, converted);
  }
}
